import { ParticipantList } from '@/components/participant-list/participant-list';
import { SponsorCarousel } from '@/components/sponsor-carousel/sponsor-carousel';
import { SwitchRenderer } from '@/components/switch-renderer';
// import { VideoBookmark } from '@/components/video-bookmark';
import { VideoContainer } from '@/components/video-container';
import { VideoPlayerLive } from '@/components/video-player';
// import { useCachedState } from '@/hooks/useCachedState';
import { useMuxSrcConstructor } from '@/hooks/useMuxSrcConstructor';
import { useSessionStatus } from '@/hooks/useSessionStatus';
import PollList from '@/js/live/components/PollList';
import { LiveContainer } from '@/js/live/LiveContainer';
import EventDescription from '@/js/shared/components/info/EventDescription';
import {
  CounterIcon,
  LiveUsersProvider,
} from '@/js/shared/components/live-users';
import Chat from '@/js/shared/components/ui/Chat';
import CoSnackbar from '@/js/shared/components/ui/CoSnackbar';
import { AuthContext } from '@/js/shared/context/AuthContext';
import { MessageContext } from '@/js/shared/context/MessageContext';
import { PollContext } from '@/js/shared/context/PollContext';
import { PusherContext } from '@/js/shared/context/PusherContext';
import { RoomContext } from '@/js/shared/context/RoomContext';
// import { daysLeft } from '@/js/shared/utils/DataFormat';
import { IProgramRoom } from '@/types/room';
import { IUser } from '@/types/user';
import {
  WidgetArea,
  WidgetContextProvider,
  WidgetController,
} from '@/widget-editor/components';

import {
  Badge,
  Box,
  Button,
  CircularProgress,
  Grid,
  Icon,
  Link,
  makeStyles,
  Tab,
  Tabs,
  Theme,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import { TabContext, TabPanel } from '@material-ui/lab';
import { styled } from '@material-ui/styles';
import axios from 'axios';
import React, {
  FC,
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { RouteComponentProps } from 'react-router-dom';
import C from '../../../shared/constants/general';
import queryString from 'query-string';

type Tabs = 'info' | 'all' | 'moderator' | 'people';

interface ISnackBarOptions {
  open: boolean;
  text: string;
  duration: number;
}

interface IMainProps {
  room: IProgramRoom;
  setSnackbar: (options: ISnackBarOptions) => void;
  addTimeReaction: (roomId: string) => void;
  moderatorOrSpeaker: boolean;
}

interface ITabUpdates {
  all: number;
  studio: number;
  moderator: number;
  info: number;
}

interface IAsideProps {
  user: IUser;
  room: IProgramRoom;
  currentTab: Tabs;
  setCurrentTab: (value: Tabs) => void;
  setSnackbar: (options: ISnackBarOptions) => void;
  showStudioTab: boolean;
  messageState: any;
  messageActions: any;
  updatedTabs: ITabUpdates;
}

type IContainerProps = RouteComponentProps & {
  user: IUser;
  match: {
    params: {
      roomId: string;
    };
  };
};

const useMainStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 100%',
  },
  contentSection: {
    display: 'none',
    padding: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },
  studioIframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    border: 0,
    width: '100%',
    height: '100%',
  },
  studioCounter: {
    position: 'absolute',
    top: 1,
    right: 1,
    borderRadius: 3,
    backgroundColor: '#000000AA',
    fontSize: 13,
    padding: '0 5px',
    '&>div': {
      flexDirection: 'row-reverse',
    },
    '& span': {
      fontSize: 11,
      margin: '0 auto',
      marginTop: 3,
    },
  },
}));

const Main: FC<IMainProps> = ({
  room,
  setSnackbar,
  addTimeReaction,
  children,
  moderatorOrSpeaker,
}) => {
  const classes = useMainStyles();

  const sessionStatus = useSessionStatus(room);
  const studioRef = useRef<
    | (HTMLIFrameElement & {
        contentWindow: {
          updateRoomState: (state: any) => void;
        };
      })
    | null
  >();

  useEffect(() => {
    if (
      studioRef.current &&
      studioRef.current.contentWindow &&
      studioRef.current.contentWindow.updateRoomState
    ) {
      // Send state change to the studio (that dont have Pusher)
      const { video_state, video_access } = room;
      console.log('updateRoomState', { video_state, video_access });
      studioRef.current.contentWindow.updateRoomState({
        video_state,
        video_access,
      });
    } else {
      console.log(
        'sessionStatus',
        room.video_state,
        room.video_access,
        studioRef.current
      );
    }
  }, [room.video_state, room.video_access]);

  const logView = () => {
    axios.post(`/api/visitor/rooms/${room.id}/logview`);
  };
  const LOGVIEW_INTERVAL = 10 * 60 * 1000; // 10 minutes

  useEffect(() => {
    if (sessionStatus === 'live') {
      // if (sessionStatus === 'waiting') {
      logView();
      const logInterval = setInterval(logView, LOGVIEW_INTERVAL);
      return () => clearInterval(logInterval);
    }
  }, [sessionStatus]);
  // const saveBookmark = () => {
  //   addTimeReaction(room.id);
  //   setSnackbar({
  //     open: true,
  //     text: `Favorite added`,
  //     duration: 2000,
  //   });
  // };

  // const getTimeLeft = (room: IMainProps['room']) => {
  //   if (room.programDay.date) {
  //     const days = Math.floor(daysLeft(room.programDay.date));
  //     if (days === 0) {
  //       return ``;
  //     } else if (days > 0) {
  //       return `Starts in ${days} day${days > 1 ? 's' : ''}`;
  //     } else {
  //       return `${Math.abs(days)} day${
  //         Math.abs(days) > 1 ? 's' : ''
  //       } ago, seems there was no live stream`;
  //     }
  //   }
  //   return '';
  // };

  return (
    <main className={classes.root}>
      <VideoContainer
        displayBackdrop={!['live', 'studio'].includes(sessionStatus)}
      >
        <SwitchRenderer
          switchCase={sessionStatus}
          render={{
            finished: () => (
              <Typography
                variant="subtitle2"
                align="center"
                style={{ color: '#FFFFFF' }}
              >
                {window.LANG.LIVE_AFTER_1}
                <br />
                <Link href={`/live`} color="primary">
                  {window.LANG.LIVE_AFTER_2}
                </Link>{' '}
                {window.LANG.LIVE_AFTER_3}
              </Typography>
            ),
            paused: () => (
              <Typography
                variant="subtitle2"
                align="center"
                style={{ color: '#FFFFFF' }}
              >
                {window.LANG.LIVE_PAUSE}
              </Typography>
            ),
            paused_no_event: () => (
              <Typography
                variant="subtitle2"
                align="center"
                style={{ color: '#FFFFFF' }}
              >
                {window.LANG.LIVE_PAUSE}
              </Typography>
            ),
            waiting: () => (
              <Typography
                variant="subtitle2"
                align="center"
                style={{ color: '#FFFFFF' }}
              >
                {window.LANG.LIVE_WAIT}
              </Typography>
            ),
            live: () => (
              <VideoPlayerLive
                source={useMuxSrcConstructor({
                  srcToken: room.mux_current_live_jwt,
                  playbackId: room.mux_current_live_playback_id,
                })}
              >
                {/* <VideoBookmark isActive={true} onClick={saveBookmark} /> */}
                {window.SETTINGS.USE_ONLINECOUNT && (
                  <LiveUsersProvider roomId={room.id}>
                    <CounterIcon style="stacked" />
                  </LiveUsersProvider>
                )}
              </VideoPlayerLive>
            ),
            studio: () => (
              <>
                <iframe
                  ref={studioRef}
                  className={classes.studioIframe}
                  frameBorder="0"
                  allow="autoplay;fullscreen;camera;microphone"
                  src={`/embedstudio/${room.id}`}
                />
                <div className={classes.studioCounter}>
                  <LiveUsersProvider roomId={room.id}>
                    <CounterIcon style="stacked" />
                  </LiveUsersProvider>
                </div>
              </>
            ),
          }}
        />
      </VideoContainer>
      <section className={classes.contentSection}>{children}</section>
    </main>
  );
};

const StyledBadge = styled(Badge)(({ theme }: { theme: any }) => ({
  '& .MuiBadge-badge': {
    right: 'auto',
    left: -2,
    top: 1,
    fontSize: 9,
    border: `2px solid ${theme.palette.background.default}`,
    padding: 0,
  },
}));

const useAsideStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    flexShrink: 0,
    [theme.breakpoints.up('md')]: {
      width: '270px',
    },
  },
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: 'inherit',
    top: 0,
    [theme.breakpoints.up('md')]: {
      position: 'fixed',
      top: 48,
      right: 0,
      bottom: 0,
      maxHeight: 'calc(100vh - 48px)',
    },
  },
  tabsRoot: {
    marginBottom: theme.spacing(1),
    minHeight: 38,
  },
  tabsContainer: {
    justifyContent: 'space-around',
  },
  tabRoot: {
    minWidth: 'auto',
    minHeight: 38,
    fontSize: 13,
    padding: 2,
  },
  tabRootTight: {
    minWidth: 'auto',
    minHeight: 38,
    padding: 2,
    fontSize: 12,
    '& .MuiIcon-root': {
      display: 'block',
      margin: '0 auto',
    },
  },
  tabIcon: {
    fontSize: '18px',
    verticalAlign: 'middle',
  },
  tabSm: {
    display: 'inline-flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  tabPanelRoot: {
    position: 'relative',
    padding: 0,
    flex: 1,
    overflow: 'hidden',
  },
  chat: {
    flex: 1,
    height: '100%',
    // maxHeight: 'calc(100vh - 105px)',
  },
}));

const Aside: FC<IAsideProps> = ({
  user,
  room,
  currentTab,
  setCurrentTab,
  setSnackbar,
  showStudioTab,
  messageState,
  messageActions,
  children,
  updatedTabs,
}) => {
  const classes = useAsideStyles();

  const { isConnected, ROOM_TYPE } = useContext(PusherContext);
  const { dispatch: pollDispatch, actions: pollActions } = useContext(
    PollContext
  );

  const smallScreen = useMediaQuery(
    (theme: Theme) => theme.breakpoints.down('sm'),
    {
      noSsr: true,
    }
  );

  const tabLabel = (icon: string, label: string) => {
    return (
      <span>
        {!!icon && <Icon classes={{ root: classes.tabIcon }}>{icon}</Icon>}
        {` ${label}`}
      </span>
    );
  };

  const postChatMessage = (msg: string) => {
    messageActions.postMessage(ROOM_TYPE.ROOM, room.id, currentTab, {
      eventId: room.currentEventId,
      text: msg,
    });
  };

  const postModerateMessage = (messageId: string, isMine: unknown) => {
    messageActions.moderateMessage(messageId, isMine);
  };

  const postMessageToAsk = (messageId: string) => {
    messageActions.moderateMessageToAsk(messageId, () => {
      setSnackbar({
        open: true,
        text: `Sent to ASK`,
        duration: 2000,
      });
    });
  };

  const tabClass = showStudioTab ? classes.tabRootTight : classes.tabRoot;

  const chat = (
    <Chat
      programRoomId={room.id}
      reverse={smallScreen}
      connected={isConnected}
      className={classes.chat}
      messageToAsk={postMessageToAsk}
      postModerate={postModerateMessage}
      postHandler={postChatMessage}
      channel={currentTab}
      progress={messageState.messageListProgress}
      list={messageState.messageList}
      user={user}
    />
  );

  useEffect(() => {
    if (room.currentPollId) {
      pollActions.loadPollWithAnswer(room.currentPollId);
    } else {
      pollDispatch({ type: 'POLL_SUCCESS', poll: null });
    }
  }, [room.currentPollId, room.id]);

  return (
    <aside className={classes.root}>
      <div className={classes.container}>
        {smallScreen && <PollList />}
        <TabContext value={currentTab}>
          <Tabs
            classes={{
              root: classes.tabsRoot,
              flexContainer: classes.tabsContainer,
            }}
            value={currentTab}
            onChange={(_e, value) => setCurrentTab(value)}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            <Tab
              className={classes.tabSm}
              classes={{ root: tabClass }}
              value="info"
              label={
                <StyledBadge badgeContent={updatedTabs.info} color="primary">
                  {tabLabel('info', window.LANG.BTN_INFO)}
                </StyledBadge>
              }
            />
            {window.LANG.BTN_CHAT && (
              <Tab
                classes={{ root: tabClass }}
                value="all"
                label={
                  <StyledBadge badgeContent={updatedTabs.all} color="primary">
                    {tabLabel('chat', window.LANG.BTN_CHAT)}
                  </StyledBadge>
                }
              />
            )}
            {window.LANG.BTN_ASK && (
              <Tab
                classes={{ root: tabClass }}
                value="moderator"
                label={
                  <StyledBadge
                    badgeContent={updatedTabs.moderator}
                    color="primary"
                  >
                    {tabLabel('pan_tool', window.LANG.BTN_ASK)}
                  </StyledBadge>
                }
              />
            )}

            {showStudioTab && (
              <Tab
                classes={{ root: tabClass }}
                value="studio"
                label={
                  <StyledBadge
                    badgeContent={updatedTabs.studio}
                    color="primary"
                  >
                    {tabLabel('voice_chat', 'Studio')}
                  </StyledBadge>
                }
              />
            )}
            {window.LANG.BTN_PEOPLE && (
              <Tab
                classes={{ root: tabClass }}
                value="people"
                label={tabLabel('people', window.LANG.BTN_PEOPLE)}
              />
            )}
          </Tabs>
          <TabPanel
            style={{ padding: '0 16px' }}
            classes={{ root: classes.tabPanelRoot }}
            className={classes.tabSm}
            value="info"
          >
            {children}
          </TabPanel>
          {window.LANG.BTN_CHAT && (
            <TabPanel classes={{ root: classes.tabPanelRoot }} value="all">
              {chat}
            </TabPanel>
          )}
          {window.LANG.BTN_ASK && (
            <TabPanel
              classes={{ root: classes.tabPanelRoot }}
              value="moderator"
            >
              {chat}
            </TabPanel>
          )}
          <TabPanel classes={{ root: classes.tabPanelRoot }} value="studio">
            {chat}
          </TabPanel>
          {window.LANG.BTN_PEOPLE && (
            <TabPanel classes={{ root: classes.tabPanelRoot }} value="people">
              <ParticipantList
                conferenceId={room.conferenceId}
                roomId={room.id}
                update={Math.floor(Math.random() * (10 - 1 + 1) + 1)}
              />
            </TabPanel>
          )}
        </TabContext>
        {!smallScreen && (
          <Fragment>
            {room.settings && room.settings.sponsors && (
              <SponsorCarousel
                contact={room.settings.contact}
                timeout={room.settings.timeout}
                data={room.settings.sponsors}
              />
            )}
            <PollList />
          </Fragment>
        )}
      </div>
    </aside>
  );
};

const useContainerStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  widgetsMobile: {
    width: '100%',
  },
}));

const ToStudioButton = ({
  room,
  moderatorOrSpeaker,
}: {
  room: any;
  moderatorOrSpeaker: boolean;
}) => {
  const [studioAccess, setStudioAccess] = useState(false);
  const sessionStatus = useSessionStatus(room);

  useEffect(() => {
    if (moderatorOrSpeaker) {
      axios.get(`/api/visitor/rooms/${room.id}/studio`).then((response) => {
        try {
          setStudioAccess(!!response.data.studio_setting);
        } catch (e) {
          console.error('Could not read studio details', e);
        }
      });
    } else {
      setStudioAccess(false);
    }
  }, [room.id]);
  return studioAccess ? (
    <Box pb={1}>
      {sessionStatus === 'studio' ? (
        <Button
          startIcon={<Icon>logout</Icon>}
          color="secondary"
          href={`/live/room/${room.id}`}
          size="small"
          variant="contained"
        >
          Exit studio
        </Button>
      ) : (
        <Button
          startIcon={<Icon>voice_chat</Icon>}
          color="primary"
          href={`/live/room/${room.id}?studio=1`}
          variant="contained"
          size="small"
        >
          To studio
        </Button>
      )}
    </Box>
  ) : null;
};

export const LiveRoom = ({
  location,
  match: {
    params: { roomId },
  },
  user,
}: IContainerProps) => {
  const classes = useContainerStyles();

  const { pusher, ROOM_TYPE, actions: pusherActions } = useContext(
    PusherContext
  );
  const { authState } = useContext(AuthContext);

  const {
    roomState,
    actions: roomActions,
    dispatch: roomDispatch,
  } = useContext(RoomContext);

  const {
    messageState,
    dispatch: messageDispatch,
    actions: messageActions,
  } = useContext(MessageContext);

  const { roomLoaded, room, hasTicketAccess } = roomState;

  const [updatedTabs, setUpdatedTabs] = useState<ITabUpdates>({
    all: 0, // Regular chat
    studio: 0, // Studio Chat
    moderator: 0, // ASK Chat
    info: 0, // Widget updates
  });

  const showStudioTab = !!queryString.parse(location.search).studio;

  const startTab = [
    ...(showStudioTab ? ['studio'] : []),
    ...(window.LANG.BTN_CHAT ? ['all'] : []),
    ...(window.LANG.BTN_ASK ? ['moderator'] : []),
    ...(window.LANG.BTN_PEOPLE ? ['people'] : []),
  ][0];

  const [roomCurrentTab, setCurrentTab] = useState(startTab);
  const realCurrentTab = useRef(startTab);
  const loadedWithNoTicketAccess = roomLoaded && !hasTicketAccess;

  useEffect(() => {
    realCurrentTab.current = roomCurrentTab;
  }, [roomCurrentTab]);

  const moderatorOrSpeaker =
    authState.user.access_level === C.VISITOR.ACCESS_LEVEL.MODERATOR ||
    authState.user.participation_level ===
      C.VISITOR.PARTICIPATION_LEVEL.CONTRIBUTE;

  const snackRef = useRef<{
    setState: (options: ISnackBarOptions) => void;
  } | null>(null);

  const setSnackBar = (options: ISnackBarOptions) => {
    snackRef.current && snackRef.current.setState(options);
  };

  const checkTabUpdated = (tab: string, call?: () => void) => {
    if (tab === realCurrentTab.current) {
      call && call();
    } else {
      setUpdatedTabs((oldVal) => {
        const newVal = { ...oldVal };
        if (newVal.hasOwnProperty(tab)) {
          newVal[tab] = newVal[tab] + 1;
        }
        return newVal;
      });
    }
  };
  useEffect(() => {
    if (pusher.current == null || loadedWithNoTicketAccess) return;

    const roomChannel = pusherActions.subscribe(ROOM_TYPE.ROOM, roomId);
    let moderatorRoomChannel;

    pusherActions.subscribe(ROOM_TYPE.LISTROOM, `${roomId}-${user.id}`);

    roomChannel.bind('new-message', (message: { visitorId: string }) => {
      // if (user.id === message.visitorId) {
      checkTabUpdated('all', () =>
        messageDispatch({ type: 'MESSAGE_NEW', post: message })
      );

      // }
    });

    if (moderatorOrSpeaker) {
      moderatorRoomChannel = pusherActions.subscribe(
        ROOM_TYPE.MODERATORROOM,
        roomId
      );

      moderatorRoomChannel.bind(
        'new-moderator-message',
        (message: { visitorId: string }) => {
          checkTabUpdated('moderator', () =>
            messageDispatch({ type: 'MESSAGE_NEW', post: message })
          );
        }
      );

      moderatorRoomChannel.bind(
        'new-studio-message',
        (message: { visitorId: string }) => {
          checkTabUpdated('studio', () =>
            messageDispatch({ type: 'MESSAGE_NEW', post: message })
          );
        }
      );
    }

    roomChannel.bind('moderated-message', (message: unknown) => {
      messageDispatch({ type: 'MESSAGE_MODERATE_SUCCESS', post: message });
    });

    roomChannel.bind('room-updated', (data: unknown) => {
      roomDispatch({ type: 'ROOM_SUCCESS', room: data });
    });

    roomChannel.bind('room-reload', () =>
      setTimeout(
        () => roomActions.reloadRoomDetail(roomId),
        Math.floor(Math.random() * 5000)
      )
    );

    return () => {
      pusherActions.unSubscribe(ROOM_TYPE.ROOM, roomId);
      moderatorOrSpeaker &&
        pusherActions.unSubscribe(ROOM_TYPE.MODERATORROOM, roomId);
      pusherActions.unSubscribe(ROOM_TYPE.LISTROOM, `${roomId}-${user.id}`);
    };
  }, [pusher.current, loadedWithNoTicketAccess, roomId]);

  useEffect(() => {
    if (['all', 'moderator', 'studio'].includes(roomCurrentTab)) {
      // Reload chat messages
      messageActions.loadMessageList(ROOM_TYPE.ROOM, roomId, roomCurrentTab);
    }
    setUpdatedTabs((oldVal) => {
      const newVal = { ...oldVal };
      if (newVal.hasOwnProperty(roomCurrentTab)) {
        newVal[roomCurrentTab] = 0;
      }
      return newVal;
    });
  }, [roomCurrentTab, roomId]);

  useEffect(() => {
    roomActions.loadRoomDetail(roomId);
  }, [roomId]);

  useEffect(() => {
    roomDispatch({
      type: 'CURRENT_EVENT',
      event: (room && room.currentEvent) || null,
    });
  }, [room && room.currentEventId, roomId]);

  return (
    <WidgetContextProvider user={user} roomId={roomId}>
      <LiveContainer
        programRoomId={roomId}
        isActive={(to: string) => to === location.pathname}
        extraTopButtons={
          user.access_level === C.VISITOR.ACCESS_LEVEL.MODERATOR && (
            <WidgetController roomId={roomId} />
          )
        }
        header={
          roomLoaded &&
          room && (
            <ToStudioButton
              room={room}
              moderatorOrSpeaker={moderatorOrSpeaker}
            />
          )
        }
      >
        {loadedWithNoTicketAccess ? (
          <Box textAlign="center" pt={4}>
            <Typography variant="h5">
              <Icon>lock</Icon>
              <br />
              {(window as any).LANG.TICKET_ACCESS_MSG}
            </Typography>
          </Box>
        ) : roomLoaded && room ? (
          <div className={classes.root}>
            <Main
              room={room}
              setSnackbar={setSnackBar}
              addTimeReaction={roomActions.addTimeReaction}
              moderatorOrSpeaker={moderatorOrSpeaker}
            >
              <Grid container spacing={1}>
                <Grid item sm={6}>
                  <WidgetArea area="area-1" />
                </Grid>
                <Grid item sm={6}>
                  <WidgetArea area="area-2" />
                </Grid>
              </Grid>
            </Main>
            <Aside
              user={user}
              room={room}
              messageState={messageState}
              messageActions={messageActions}
              showStudioTab={showStudioTab}
              currentTab={roomCurrentTab}
              setCurrentTab={(tab: Tabs) => setCurrentTab(tab)}
              setSnackbar={setSnackBar}
              updatedTabs={updatedTabs}
            >
              <div className={classes.widgetsMobile}>
                <WidgetArea area="area-2" />
                <WidgetArea area="area-1" />
              </div>
            </Aside>
            <CoSnackbar ref={snackRef} />
          </div>
        ) : (
          <div style={{ margin: 'auto' }}>
            <CircularProgress disableShrink />
          </div>
        )}
      </LiveContainer>
    </WidgetContextProvider>
  );
};
